export const normalizeWorspaces = data =>
  data
    .map(item => ({
      id: item.id,
      name: item.name,
      appId: item.app_id,
      isClient: item.is_client,
      memberRole: item.member_role
    }))
    .filter(item => !item.isClient);

export const normalizeWorspaceSettings = data => ({
  id: data.id,
  botIcon: data.bot_icon,
  trayIcon: data.tray_icon,
  botName: data.bot_name,
  logo: data.logo,
  primaryColor: data.primary_color,
  secondaryColor: data.secondary_color,
  salesBoard: data.sales_board,
  supportBoard: data.support_board,
  successIcon: data.success_icon,
  warningIcon: data.warning_icon,
  infoIcon: data.info_icon,
  overrideDesign: data.override_design
});

export const normalizeUserData = data => ({
  createdAt: data.created_at,
  email: data.email,
  fullname: data.full_name,
  flowItemsReady: data.flow_items_ready,
  userId: data.user_id,
  memberId: data.member_id,
  isMemberSynced: data.is_member_synced,
  cwConfiguration: data.cw_configuration,
  chatConfiguration: data.chat_configuration,
  featureFlags: data.feature_toggles || [],
  actionPlatform: data.feature_toggles && data.feature_toggles.action_platform,
  botInstalled: data.chat_configuration === 'SLACK' || data.bot_installed,
  slackHasNewConfiguration: data.slack_has_new_configuration === 0, // Invert condition NEED FIX after relise
  msTeamsHasNewConfiguration: data.msteams_has_new_configuration === 0, // Invert condition NEED FIX after relise
  roles: data.roles?.reduce((obj, index) => ({ [index]: true, ...obj }), {}) || {},
  subscription: data.subscription,
  isFlows: !!data.flow_count,
  isClient: data.is_client,
  psaType: data.psa_type,
  hasPaidPlan: data.has_paid_plan,
  threadServiceUrl: data.thread_service_url || '',
  isMagicAiEnabled: data.is_magic_ai_enabled,
  company: {
    ...data.company,
    settings: data.company?.settings ? normalizeWorspaceSettings(data.company.settings) : {},
    appId: data.company?.app_id,
    primary_color: /^#[0-9A-F]{6}$/i.test(data.company?.primary_color)
      ? data.company.primary_color
      : '',
    secondary_color: /^#[0-9A-F]{6}$/i.test(data.company?.secondary_color)
      ? data.company.secondary_color
      : ''
  }
});

export const messageNormalizer = message => ({
  sid: message.sid,
  member: message.attributes.author,
  memberId: message.attributes.memberId,
  contactId: message.attributes.contactId,
  text: message.body || '',
  card: message.attributes.adaptive_card,
  date: message.dateCreated,
  isInternal: !!message.attributes.is_internal,
  index: message.index,
  type: message.type,
  media: message.media,
  userType: message.attributes.user_type,
  source: message.attributes.source,
  activityMsg: message.attributes?.activity
});
